import React, { useContext } from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { languageOptions } from '../languages';

import { LanguageContext } from './LangaugeContainer';
import { useDispatch} from 'react-redux'
import { SetLanguage } from '../actions/SettingsActions';

export default function LanguageSelector() {
    const languageContext = useContext(LanguageContext);
    const dispatch = useDispatch();

    const handleLanguageChange = (event) => {
        const selectedLanguage = languageOptions.find(item => item.id === event.target.value);
        // set selected language by calling context method
        languageContext.setLanguage(selectedLanguage);
        dispatch(SetLanguage(selectedLanguage));
    };

    return (
        <div>
            <FormControl>
                {/* <InputLabel id="demo-simple-select-label">Lang</InputLabel> */}
                <Select
                    style={{color: '#ffffff'}}
                    labelid="demo-simple-select-label"
                    id="demo-simple-select"
                    value={languageContext.language.id}
                    onChange={handleLanguageChange}
                >
                     {languageOptions.map(item => (
                <MenuItem
                    key={item.id}
                    value={item.id}
                >
                    {item.text}
                </MenuItem>
            ))}

                </Select>
            </FormControl>
        </div>
    );
}
